"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextReplacer = void 0;
const json_utils_1 = require("./json-utils");
class TextReplacer {
    static extractKeys(str) {
        const regex = new RegExp("\\$\\{([a-z.0-9]*)\\}", "ig");
        let result;
        const keys = [];
        do {
            result = regex.exec(str);
            if (result !== null) {
                keys.push(result[1]);
            }
        } while (result !== null);
        return keys;
    }
    static replace(content, context, removeUnmappedContent = false) {
        if (!content)
            return;
        if (context) {
            // replace conditionals
            // eslint-disable-next-line no-useless-escape
            const conditionals = /#{if ([^}]*)}([^#]*)#{\/if}/m;
            let m;
            while ((m = conditionals.exec(content)) !== null) {
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === conditionals.lastIndex) {
                    conditionals.lastIndex++;
                }
                const conditionalBlock = m[0];
                let conditionalProp = m[1];
                let condition = context[conditionalProp] !== undefined &&
                    context[conditionalProp] !== null &&
                    context[conditionalProp] !== "";
                if (conditionalProp.startsWith("not ")) {
                    conditionalProp = conditionalProp.replace("not ", "");
                    condition =
                        context[conditionalProp] === undefined ||
                            context[conditionalProp] === null ||
                            context[conditionalProp] === "";
                }
                const conditionalContent = m[2];
                if (condition)
                    content = content.replace(conditionalBlock, conditionalContent);
                else
                    content = content.replace(conditionalBlock, "");
            }
        }
        // replace content
        const keys = TextReplacer.extractKeys(content);
        for (const key of keys) {
            const replacer = (0, json_utils_1.getJsonByPath)(context, key);
            if (replacer !== undefined) {
                content = content.replace(new RegExp(`\\$\{${key}}`, "ig"), replacer);
            }
        }
        // check if everything got replaced
        const regex = new RegExp("\\$\\{[a-z.0-9]*\\}", "ig");
        const result = regex.exec(content);
        if (result !== null)
            console.error("TextReplacer", "Some text could not get replaced: ", { result, context });
        if (removeUnmappedContent) {
            content = content.replace(regex, "");
        }
        return content;
    }
    static replaceInObject(obj, context, removeUnmappedContent = false) {
        return JSON.parse(TextReplacer.replace(JSON.stringify(obj), context, removeUnmappedContent));
    }
}
exports.TextReplacer = TextReplacer;
